// External Libraries
import { isFunction } from '@checkout/react-components';

// Internal modules
import { appStore } from '@/store';
import {
  blurHandler,
  changeHandler as genericChangeHandler,
} from '../../../Form/handlers';
import { logBlurOrFocusEvent as focusHandler } from '../../../Form/utils';
import { maskingFunctionMap } from './utils';

const changeHandler = (e, value, ...rest) => {
  const { form: formState } = appStore.getState();
  const { value: identityDocumentType } = formState.identityDocumentType;

  if (isFunction(maskingFunctionMap[identityDocumentType])) {
    value = maskingFunctionMap[identityDocumentType](value);
  }

  genericChangeHandler(e, value, ...rest);
};

export { blurHandler, changeHandler, focusHandler };
